import { getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createEmployerDeductionTypesFetchedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.EMPLOYER_DEDUCTION_TYPES_FETCHED,
        ...getUserAndEventTime(),
        data: {
            uri: 'https://api.atomicfi.com/employers/645a7b94fa36054ae06b7559/employer-deduction-types',
            employerId: '645a7b94fa36054ae06b7559',
            validationErrors: {
                instancePath: '/categoryType',
                schemaPath: '#/properties/categoryType/enum',
                keyword: 'enum',
                params: {
                    allowedValues: ['post-tax', 'pre-tax']
                },
                message: 'must be equal to one of the allowed values',
                value: '',
                data: {
                    label: 'deduction 1',
                    category: 'other',
                    categoryType: '',
                    endDate: '4712-12-31T00:00:00.000Z',
                    startDate: '2023-12-03T00:00:00.000Z'
                }
            }
        }
    };
};
//# sourceMappingURL=employer-deduction-types-fetched.js.map